import React from "react";
import { Grid, Typography } from "@mui/material";

const DetailItem = ({ label, value, children }) => (
  <Grid item xs={12} sm={6}>
    <Typography variant="body2" color="text.secondary" gutterBottom>
      {label}
    </Typography>
    {children ? (
      // If custom content (like a Chip) is passed, render it
      children
    ) : (
      // Otherwise, render the standard text value
      <Typography
        variant="body1"
        fontWeight="500"
        sx={{ wordWrap: "break-word" }}
      >
        {value ?? "N/A"}
      </Typography>
    )}
  </Grid>
);

export default DetailItem;
